import CodeBlockExt from "@tiptap/extension-code-block";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ShikiPlugin } from "../../extensions/CodeBlock/shiki-plugin";
import CodeBlockActiveButton from "../../extensions/CodeBlock/components/CodeBlockActiveButton";
import { DEFAULT_LANGUAGE_CODE_BLOCK } from "../../constants";
import { NodeViewCodeBlock } from "../../extensions/CodeBlock/components/NodeViewCodeBlock/NodeViewCodeBlock";

export const CodeBlock = CodeBlockExt.extend({
	addOptions() {
		return {
			...this.parent?.(),
			languages: [],
			button: ({ editor, t, extension }) => {
				const languages = extension?.options?.languages?.length
					? extension?.options?.languages
					: DEFAULT_LANGUAGE_CODE_BLOCK;

				return {
					component: CodeBlockActiveButton,
					componentProps: {
						action: (language = "js") =>
							editor.commands.setCodeBlock({
								language
							}),
						isActive: () => editor.isActive("codeBlock") || false,
						icon: "Code2",
						tooltip: t("editor.codeblock.tooltip"),
						languages
					}
				};
			}
		};
	},
	addNodeView() {
		return ReactNodeViewRenderer(NodeViewCodeBlock);
	},
	addProseMirrorPlugins() {
		return [
			...(this.parent?.() || []),
			ShikiPlugin({
				name: this.name,
				defaultLanguage: null,
				defaultTheme: this.options.defaultTheme
			})
		];
	}
});
